import { STRATEGY_ORDER_COUNT_INPUT_ID } from "testIds";
import React from "react";
import SliderAndInput from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem/SliderAndInput";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { useStrategyNumOrders } from "@shared/features/bots/BotForm/common/hooks";
import TitleWithToggle from "features/bots/BotForm/common/TitleWithToggle";
import Text from "common/Typography/Text";
import EqualColumnsGrid from "common/Grids/EqualColumnsGrid";
import { openMessage } from "utils/misc";
import {
  overlayStyles,
  OverlayStylesProps,
} from "@shared/common/Overlays/Overlay";
import styled from "styled-components";
import { useBottomNavigator } from "utils/hooks/misc.tsx";

const StrategyNumOrders = () => {
  const { numOrdersSelectorData, toggleFieldData, singleColumnLayout } =
    useStrategyNumOrders();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  const numOrdersSelector = numOrdersSelectorData?.show ? (
    <SliderAndInput
      inputTestId={STRATEGY_ORDER_COUNT_INPUT_ID}
      key={numOrdersSelectorData.title}
      name={
        toggleFieldData.isToggleField ? undefined : numOrdersSelectorData.title
      }
      value={numOrdersSelectorData.value}
      setValue={numOrdersSelectorData.onChange}
      maxValue={numOrdersSelectorData.maxValue}
      step={numOrdersSelectorData.step}
      minValue={numOrdersSelectorData.minValue}
      showError={numOrdersSelectorData.showError}
      useDebounce={true}
      placeholder={numOrdersSelectorData.placeholder}
      helperTooltip={
        toggleFieldData.isToggleField ? undefined : (
          <HelperTooltip {...numOrdersSelectorData.helperTooltipData} />
        )
      }
    />
  ) : undefined;

  if (toggleFieldData.isToggleField) {
    const clickWarning = numOrdersSelectorData.clickWarning;
    return (
      <div
        style={{
          marginBottom: 16,
          position: "relative",
        }}
      >
        {!!clickWarning && (
          <OverlayWrapper
            $isBottomNavigator={isBottomNavigator}
            onClick={() => openMessage(clickWarning, "warning")}
          />
        )}
        <TitleWithToggle
          title={
            <Text as="div">
              {numOrdersSelectorData.title}
              <HelperTooltip {...numOrdersSelectorData.helperTooltipData} />
            </Text>
          }
          content={
            <EqualColumnsGrid
              numColumns={singleColumnLayout ? 1 : 2}
              style={{ marginBottom: -8, paddingLeft: 4 }}
              rowGap={4}
            >
              {numOrdersSelector}
            </EqualColumnsGrid>
          }
          fieldType={toggleFieldData.fieldType}
        />
      </div>
    );
  }

  return <>{numOrdersSelector}</>;
};

export default StrategyNumOrders;

export const OverlayWrapper = styled.div<
  {
    $isBottomNavigator?: boolean;
  } & OverlayStylesProps
>`
  ${overlayStyles};
  background-color: ${(p) =>
    p.$isBottomNavigator
      ? p.theme.colors.layoutBgColor
      : p.theme.colors.cardBgColor};
`;
